import * as React from 'react';
import styled from '@emotion/styled';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import { useNavigate } from 'react-router-dom';
import { useProvideAuth } from '../../../utils/authentication/use-Auth';

const StyledLogo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #ffffff;
`;

const StyledIcon = {
  margin: '0 1rem',
  color: '#ffffff',
};

const StyledDirectory = styled.h3`
  cursor: pointer;
`;

const Logo = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loginWithRedirect } = useProvideAuth();

  return (
    <StyledLogo>
      <LocalHospitalIcon sx={StyledIcon} color="primary" />
      <StyledDirectory onClick={() => (isAuthenticated ? navigate('search') : loginWithRedirect())}>HEALTHCARE DIRECTORY</StyledDirectory>
    </StyledLogo>
  );
};

export default Logo;
